import baseConfig from './base'

//Production server
let backendHost = 'https://api.beeker.hu'
const apiVersion = 'v1'
const hostname = window && window.location && window.location.hostname

//Test server
if (hostname === '1000ut.beeker.hu') {
    backendHost = 'https://api-1000ut.beeker.hu'
}

//Local server
if (hostname === 'localhost') {
    backendHost = 'http://localhost:8080'
}

const API_ROOT = `${backendHost}/api/${apiVersion}/`
let config = {
    appEnv: 'dev',
    ENDPOINT_BASE_URL: API_ROOT,
    language: 'hu'
}

export default Object.freeze(Object.assign({}, baseConfig, config))



// WEBPACK FOOTER //
// ./src/config/dev.js